const EDITABLE_SHORTCUT_SELECTOR = ".monaco-editor, .JsEditor";
const SHORTCUT_SUPPRESSED_SELECTOR = ".ant-modal, [role='dialog']";

type UndoRedoShortcutAction = "undo" | "redo";
type UndoRedoShortcutEvent = Pick<
  KeyboardEvent,
  "key" | "metaKey" | "ctrlKey" | "shiftKey"
>;

export function getUndoRedoShortcutAction(
  event: UndoRedoShortcutEvent
): UndoRedoShortcutAction | null {
  const key = event.key.toLowerCase();
  const hasCommandModifier = event.metaKey || event.ctrlKey;

  if (hasCommandModifier && key === "z") {
    return event.shiftKey ? "redo" : "undo";
  }

  if (event.ctrlKey && !event.metaKey && key === "y") {
    return "redo";
  }

  return null;
}

export function isUndoRedoShortcut(event: UndoRedoShortcutEvent): boolean {
  return getUndoRedoShortcutAction(event) !== null;
}

export function isEditableKeyboardTarget(target: EventTarget | null): boolean {
  if (!target || typeof target !== "object") {
    return false;
  }

  const element = target as HTMLElement;
  const tagName = element.tagName;
  return (
    tagName === "INPUT" ||
    tagName === "TEXTAREA" ||
    tagName === "SELECT" ||
    element.isContentEditable ||
    Boolean(element.closest?.(EDITABLE_SHORTCUT_SELECTOR))
  );
}

export function isKeyboardShortcutSuppressedTarget(
  target: EventTarget | null
): boolean {
  if (isEditableKeyboardTarget(target)) {
    return true;
  }

  if (!target || typeof target !== "object") {
    return false;
  }

  const element = target as HTMLElement;
  return Boolean(element.closest?.(SHORTCUT_SUPPRESSED_SELECTOR));
}
